import { useMutation } from '@tanstack/react-query';
import axios from '@/lib/axios';

interface FcmRegisterPayload {
  token: string;
  device_type: string;
  userid: string;
  environment: string;
}

interface FcmRegisterResponse {
  success: boolean;
  message?: string;
}

const postFcmRegister = async (
  payload: FcmRegisterPayload
): Promise<FcmRegisterResponse> => {
  const response = await axios.post('/notifications/fcm/register/', payload);
  return response.data;
};

export const usePostNotificationsFcmRegisterMutation = () => {
  return useMutation({
    mutationFn: postFcmRegister,
  });
};
